var _path, _path2, _path3, _path4, _path5, _path6, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 60V40H60",
    stroke: "#007BFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 40H160V60",
    stroke: "#007BFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 140V160H140",
    stroke: "#007BFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 160H40V140",
    stroke: "#007BFF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70L130 130",
    stroke: "#17A2B8",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    from: "0,100",
    to: "100,0",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 70L70 130",
    stroke: "#17A2B8",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    from: "0,100",
    to: "100,0",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 85,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#007BFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.5;1;0.5",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.353a837f02f29443c969cb852dc16122.svg";
export { ForwardRef as ReactComponent };